import { seoContent } from '@/mocks/home';

export default function SeoSection() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="max-w-4xl mx-auto">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-8 text-center">
            {seoContent.heading}
          </h2>

          <div className="space-y-4 mb-14">
            {seoContent.paragraphs.map((p, i) => (
              <p key={i} className="text-foreground-600 leading-relaxed text-sm md:text-base">
                {p}
              </p>
            ))}
          </div>

          <div>
            <h3 className="font-heading text-xl font-bold text-foreground-900 mb-6 text-center">
              常见问题
            </h3>
            <div className="space-y-3">
              {seoContent.faqs.map((faq, i) => (
                <details
                  key={i}
                  className="group border border-background-200/70 rounded-xl bg-background-50 overflow-hidden"
                >
                  <summary className="flex items-center justify-between p-5 cursor-pointer hover:bg-background-100 transition-colors duration-200">
                    <span className="font-medium text-foreground-800 text-sm pr-4">{faq.question}</span>
                    <div className="w-6 h-6 flex items-center justify-center flex-shrink-0 rounded-full bg-background-200/70 text-foreground-400 group-open:bg-primary-100 group-open:text-primary-500 transition-all duration-200">
                      <i className="ri-arrow-down-s-line group-open:rotate-180 transition-transform duration-200"></i>
                    </div>
                  </summary>
                  <div className="px-5 pb-5">
                    <p className="text-foreground-500 text-sm leading-relaxed">{faq.answer}</p>
                  </div>
                </details>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}